import React from 'react';
import { Info, AlertTriangle, Lightbulb } from 'lucide-react';
interface CalloutProps {
  type: 'note' | 'warning' | 'tip';
  children: React.ReactNode;
}
export function Callout({
  type,
  children
}: CalloutProps) {
  const config = {
    note: {
      icon: Info,
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-900',
      iconColor: 'text-blue-600'
    },
    warning: {
      icon: AlertTriangle,
      bg: 'bg-orange-50',
      border: 'border-orange-200',
      text: 'text-orange-900',
      iconColor: 'text-orange-600'
    },
    tip: {
      icon: Lightbulb,
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-900',
      iconColor: 'text-green-600'
    }
  };
  const {
    icon: Icon,
    bg,
    border,
    text,
    iconColor
  } = config[type];
  return <div className={`my-6 ${bg} ${border} border rounded-lg p-4 flex gap-3`} data-id="element-20">
      <Icon className={`w-5 h-5 ${iconColor} flex-shrink-0 mt-0.5`} data-id="element-21" />
      <div className={`text-sm ${text} flex-1`} data-id="element-22">{children}</div>
    </div>;
}